export default __webpack_public_path__ + "static/media/svg-decorator-blob-7.a72c1f4f.svg";